




















































import * as _ from 'lodash';
import moment from 'moment';
import VeeValidate from 'vee-validate';

import * as fb from '@/firebase';
import store from '@/store';

import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import ErrorWrappedTextInput from '@/components/form-elements/ErrorWrappedTextInput.vue';
import { InviteCode } from '@/models/invite-code';
import { InviteCodeModelUtil } from '@/model-utils/invite-code-model-util';
import { UserModule } from '@/store/modules/user';
import { UserProfile } from '@/models/user-profile';



@Component({
  components: {
    ErrorWrappedTextInput
  }
})
export default class AddEditInviteCode extends Vue {
  public inviteCode: InviteCode = null;
  @Prop(String) public inviteCodeString?: string;
  public editMode: boolean = !!this.inviteCodeString;
  public error: string = null;
  public maxUses: string = '0';
  public usersWhoUsedThisCode: UserProfile[] = [];

  public makeIsAvailableValidator() {
    const self = this;
    return {
      getMessage(field: any, args: any) {
        return 'Invite code already used';
      },
      validate(value: any, args: any) {
        if (self.inviteCodeString == value) {
          console.log('it is the string');
          return Promise.resolve(true);
        }
        console.log(InviteCodeModelUtil.isCodeFree(value));
        return InviteCodeModelUtil.isCodeFree(value);
      }
    };
  }

  public created() {
    console.log('str', this.inviteCodeString);
    this.maxUses = '100';

    // @ts-ignore
    this.$validator.extend('is-available', this.makeIsAvailableValidator());

    if (this.inviteCodeString) {
      console.log('looking for', this.inviteCodeString);
      InviteCodeModelUtil.findInviteCode(this.inviteCodeString).then(
        (code: InviteCode) => {
          if (!code) {
            this.error = `code ${this.inviteCodeString} not found`;
          } else {
            this.inviteCode = code;
            this.maxUses = code.maxUses.toString();
            InviteCodeModelUtil.findUsersWhoUsedThisCode(code).then(users => {
              console.log('users who used this', users);
              this.usersWhoUsedThisCode = users;
            });
          }
        }
      );
    } else {
      this.inviteCode = InviteCode.empty();
      this.inviteCode.code = InviteCodeModelUtil.generateCode();
    }
  }

  public async submit(evt: Event) {
    evt.preventDefault();

    let isValid = await this.$validator.validateAll();
    this.inviteCode.maxUses = Number(this.maxUses);

    if (isValid) {
      if (this.editMode) {
        InviteCodeModelUtil.update(
          this.inviteCode,
          UserModule.userProfile
        ).then(() =>
          this.$router.push({
            name: 'EditInviteCode',
            params: { inviteCodeString: this.inviteCode.code }
          })
        );
      } else {
        InviteCodeModelUtil.add(this.inviteCode, UserModule.userProfile).then(
          () =>
            this.$router.push({
              name: 'EditInviteCode',
              params: { inviteCodeString: this.inviteCode.code }
            })
        );
      }
    }
	}
	
	private joined(userProfile: UserProfile) {
    return moment(userProfile.joinDate, 'YYYYMMDD').fromNow();
  }
}
